module.exports = __webpack_public_path__ + "static/media/js.94ae2dcd.png";